<template>
  <div>
    <ProductRecommendationsProvider
      :selectorName="selectorName"
      :pageType="DY_PAGE_TYPES.product"
      :excludeProductId="currentSpreeProduct.id"
      :pageData="pageData"
      #default="{ title, items, isLoading }"
    >
      <ProductRecommendationsCards v-bind="{ title, items, isLoading }" />
    </ProductRecommendationsProvider>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { DY_API_CAMPAIGN_SELECTOR_NAMES } from '@/config/constants'
import { DY_PAGE_TYPES } from '@/services/external-communication/dynamic-yield/dy-events'
import ProductRecommendationsProvider from '@/components/_shared/ProductRecommendations/ProductRecommendationsProvider.vue'
import ProductRecommendationsCards from '@/components/_shared/ProductRecommendations/ProductRecommendationsCards.vue'

export default {
  name: 'Recommendations',
  components: {
    ProductRecommendationsProvider,
    ProductRecommendationsCards,
  },

  props: {
    selectorName: {
      type: String,
      validator(value) {
        return Object.values([
          DY_API_CAMPAIGN_SELECTOR_NAMES.pdpProductRecommendationsTop,
          DY_API_CAMPAIGN_SELECTOR_NAMES.pdpProductRecommendationsBottom,
        ]).includes(value)
      },
    },
  },

  data() {
    return {
      DY_API_CAMPAIGN_SELECTOR_NAMES,
      DY_PAGE_TYPES,
    }
  },

  computed: {
    ...mapGetters({
      currentSpreeProduct: 'product/currentSpreeProduct',
    }),

    pageData() {
      return [this.currentSpreeProduct.sku].filter(Boolean)
    },
  },
}
</script>
